import { ThemeBorderRadiusModel } from '../../border-radius.model';

export const BorderRadius: ThemeBorderRadiusModel = {
  button: '1.75rem',
  input: '1.75rem',
  // these values come from the tailwindV4 docs.
  '3xl': '1.5rem',
  '4xl': '2rem',
};
